import React from "react";
import { Formik } from "formik";
import { TextField, Paper, FormControlLabel, MenuItem, Select, FormControl, InputLabel, withStyles, Button, Typography, Chip, FormGroup, Checkbox, CircularProgress } from "@material-ui/core";
import * as Yup from "yup";
import Autocomplete from '@material-ui/lab/Autocomplete';
import { BackButton, isSuperUser } from '../../sc-utilities';
import { hasPermission } from "../../sc-utilities";

const styles = theme => ({
    root: {
        width: "auto",
        height: "auto",
        padding: theme.spacing(2),
        margin: theme.spacing(2)
    },
    submit: {
        textTransform: 'none',
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.primary.main,
        borderRadius: '1px',
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        },
        width: "100%",
        marginTop: "10px"
    },
    formControl: {
        width: "100%"
    }
});

const RoleForm = props => {
    const { classes, formSettings, permissions, initialValues, handleSubmit, translations, isEditForm=false, customerID, userPermissions } = props;
    
    const hasAccessToAllRoles = hasPermission(userPermissions, "access_all_roles")
    
    return (
        <Paper className={classes.root}>
            {BackButton(translations)}
            <Formik
                initialValues={initialValues}
                onSubmit={handleSubmit}
                enableReinitialize={true}
                validationSchema={Yup.object().shape(formSettings.Validation)}
            >
                {formikProps => {
                    const { values, touched, errors, setFieldValue, isValid, dirty, isSubmitting, handleChange, handleBlur, handleSubmit } = formikProps;
                    return (
                        <form onSubmit={handleSubmit}>
                            <Typography variant={"h6"}>{formSettings.FormTitle ? formSettings.FormTitle : null}</Typography>
                            <TextField
                                name="Name"
                                value={values.Name}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.Name && touched.Name)}
                                placeholder={translations['name'] || 'Name'}
                                label={translations['name'] || 'Name'}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <TextField
                                name="FancyName"
                                value={values.FancyName}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.FancyName && touched.FancyName)}
                                placeholder={translations['fancy_name'] || 'Fancy name'}
                                label={translations['fancy_name'] || 'Fancy name'}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <FormControl className={classes.formControl} margin={"dense"}>
                                <InputLabel shrink>{translations["type"] || "Type"}</InputLabel>
                                <Select
                                    name="Type"
                                    value={values.Type}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={!!(errors.Type && touched.Type)}
                                    placeholder={translations["type"] || "Type"}
                                    label={translations["type"] || "Type"}
                                    margin={"dense"}
                                    disabled={!isSuperUser()}
                                    fullWidth={true}
                                >
                                    <MenuItem key={"public"} value={"public"}>
                                        {translations["public"] || "Public"}
                                    </MenuItem>
                                    <MenuItem key={"private"} value={"private"}>
                                        {translations["private"] || "Private"}
                                    </MenuItem>
                                </Select>
                            </FormControl>
                            <TextField
                                name="Module"
                                value={values.Module}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.Module && touched.Module)}
                                placeholder={translations['module'] || 'Module'}
                                label={translations['module'] || 'Module'}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <FormGroup>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            margin={"dense"}
                                            name={"Locked"}
                                            checked={values.Locked}
                                            onChange={handleChange}
                                            disabled={!isSuperUser()}
                                            color={'primary'}
                                        />
                                    }
                                    label={translations['locked'] || 'Locked'}
                                />
                            </FormGroup>
                            <Autocomplete
                                name={'Permissions'}
                                multiple
                                id="PermissionsMultiSelect"
                                options={permissions || []}
                                getOptionLabel={(option) => option.label}
                                filterSelectedOptions
                                value={values.Permissions}
                                onChange={(_, value) => setFieldValue('Permissions', value)}
                                onBlur={handleBlur}
                                renderInput={(params) => (
                                    <TextField {...params} variant="standard" fullWidth={true} label={`${translations["choose_permissions"] || "Chose permissions"}...`} />
                                )}
                                renderTags={(value, getTagProps) =>
                                    value.map((option, index) => (
                                        <Chip label={option.label} {...getTagProps({ index })} />
                                    ))
                                }
                            />
                            <div>
                                {formSettings.ButtonSubmit ? (
                                    <Button
                                        fullWidth={true}
                                        className={classes.submit}
                                        variant="contained"
                                        color={formSettings.ButtonSubmit.Color}
                                        type="submit"
                                        style={{ color: isSubmitting || !(isValid && dirty) ? null : 'white' }}
                                        disabled={isSubmitting || !(isValid && dirty) || (isEditForm && (customerID === null && !hasAccessToAllRoles))}
                                    >
                                        {isSubmitting ? <CircularProgress size={24} /> : formSettings.ButtonSubmit.Title}
                                    </Button>
                                ) : null}
                            </div>
                        </form>
                    );
                }}
            </Formik>
        </Paper>
    );
};
export default withStyles(styles, { withTheme: true })(RoleForm);
